import styled from 'styled-components';

const Wrap = styled.div`
  max-width: 760px;
  margin: 0 auto 40px;
  text-align: center;
`;

const Eyebrow = styled.div`
  color: var(--gold);
  text-transform: uppercase;
  font-weight: 900;
  letter-spacing: 0.18em;
  font-size: 0.84rem;
`;

const Title = styled.h2`
  margin: 10px 0 0;
  font-size: clamp(2.25rem, 4.2vw, 4rem);
  line-height: 0.95;
  text-transform: uppercase;
  letter-spacing: -0.04em;
`;

const Text = styled.p`
  margin: 18px auto 0;
  color: var(--muted);
  line-height: 1.7;
  font-size: 1.02rem;
`;

function SectionHeader({ eyebrow, title, text, light = false }) {
  return (
    <Wrap>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <Title style={{ color: light ? 'var(--white)' : 'var(--text)' }}>{title}</Title>
      {text && <Text style={{ color: light ? 'rgba(255,255,255,0.74)' : 'var(--muted)' }}>{text}</Text>}
    </Wrap>
  );
}

export default SectionHeader;
